import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-284a0e24"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "list"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "songitem"
};
const _hoisted_4 = {
  class: "right"
};
const _hoisted_5 = {
  key: 1,
  class: "list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "songitem"
};
const _hoisted_8 = {
  class: "right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  return _openBlock(), _createElementBlock(_Fragment, null, [$props.songList ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.songList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: item
    }, [_createElementVNode("div", {
      class: "left",
      onClick: $event => $options.playmusic(index)
    }, [_createElementVNode("span", null, _toDisplayString(index + 1), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", null, _toDisplayString(item.name), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.ar, napa => {
      return _openBlock(), _createElementBlock("span", {
        key: napa
      }, _toDisplayString(napa.name), 1);
    }), 128))])], 8, _hoisted_2), _createElementVNode("div", _hoisted_4, [item.mv != 0 ? (_openBlock(), _createBlock(_component_van_icon, {
      key: 0,
      class: "mv",
      name: "video-o",
      color: "#969696",
      size: "25",
      onClick: $event => $options.getmv(index)
    }, null, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_van_icon, {
      name: "wap-nav",
      color: "#969696",
      size: "25"
    })])]);
  }), 128))])) : _createCommentVNode("", true), $props.searchSongList ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.searchSongList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: item
    }, [_createElementVNode("div", {
      class: "left",
      onClick: $event => $options.updateIndex(item)
    }, [_createElementVNode("span", null, _toDisplayString(index + 1), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", null, _toDisplayString(item.name), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.artists, napa => {
      return _openBlock(), _createElementBlock("span", {
        key: napa
      }, _toDisplayString(napa.name), 1);
    }), 128))])], 8, _hoisted_6), _createElementVNode("div", _hoisted_8, [item.mvid != 0 ? (_openBlock(), _createBlock(_component_van_icon, {
      key: 0,
      class: "mv",
      name: "video-o",
      color: "#969696",
      size: "25",
      onClick: $event => $options.getmv(index)
    }, null, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_van_icon, {
      name: "wap-nav",
      color: "#969696",
      size: "25"
    })])]);
  }), 128))])) : _createCommentVNode("", true)], 64);
}